<h1 mat-dialog-title>Rate amount</h1>
<div mat-dialog-content>
  <div  class="
  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
  row
">
    <div
    class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
  >
    <mat-form-field appearance="fill">
      <mat-label>Select</mat-label>
      <mat-select
        [(value)]="isActive"
       
      >
        <mat-option
          value="1"
          >Active</mat-option
        >
        <mat-option
          value="0"
          >Inactive</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
  <div
  class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
  <mat-form-field appearance="fill">
    <mat-label>Type</mat-label>
    <mat-select
      [(value)]="isActive2"
     
    >
    <mat-option value="1">1st-15th</mat-option>
    <mat-option value="2">16th-30th-31st</mat-option>
    <mat-option value="3">1st</mat-option>
    <mat-option value="4">Manuallity</mat-option>
    </mat-select>
  </mat-form-field>
</div>
  <div
  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10"
>
  <mat-form-field appearance="fill">
    <mat-label>Rate amount</mat-label>
    <input matInput  [(value)]="rateAmount" [(ngModel)]="rateAmount" type="number">
  </mat-form-field>
  </div>

  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button (click)="onaddRateAmountProduct()" >Add</button>
</div>
